import React, { useEffect, useState, useRef } from 'react'
import no from '../../Assets/Images/Login/no.svg'
import './precioProducto.css'
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { useSelector, useDispatch } from 'react-redux'
import { cotizacionPriceChange } from '../../redux/actions/cotizacionActions'
import { setDiscount } from '../../redux/actions/cartActions'
import { FormatMoney, getMarginTotal } from 'Utils/functions'
import { SERVICE_PRODUCT_TYPE_ID, VAPermissions } from 'Utils/constants'
import useValidatePermission from 'Hooks/useValidatePermission'
import { NumericFormat } from 'react-number-format'
import {
  getFinalPriceAction,
  getRazonesPrecioAction,
} from 'redux/actions/clientsActions'
import { t } from 'i18next'
import { toTestId } from 'Utils/Helpers/toTestId'

const MAX_PRICE = 999999
const INSPECTION_DISCOUNT_DEFAULT = 20
const REPAIR_DISCOUNT_DEFAULT = 35

const PrecioProducto = ({
  handleModalEditPrice,
  setProductChangeValidation,
  handleModalSuccesUpdatePrecio,
  product,
  setNuevoPrecio,
  productsRef,
}) => {
  const [maxDiscount, setMaxDiscount] = useState(null)
  const [maxMargin, setMaxMargin] = useState(null)
  const [marginError, setMarginError] = useState(null)
  const [, setNewPerct] = useState(0)
  // const [showMoneyButton, setShowMoneyButton] = useState(true)
  const [anularMargen, setAnularMargen] = useState(false)
  const [priceInputValue, setPriceInputValue] = useState(
    product.isPriceChanged || product.NegotiatedReason
      ? parseFloat(product.Price)
      : ''
  )
  const [discountType, setDiscountType] = useState(
    product.VisitDiscountType ?? null
  )
  const [discountAmount, setDiscountAmount] = useState(
    product.VisitDiscountAmount ?? null
  )
  const [discountDropdownOpen, setDiscountDropdownOpen] = useState(false)
  const discountDropdownRef = useRef(null)

  const discountOptions = [
    { value: null, label: 'Sin descuento' },
    {
      value: 'inspection',
      label: 'Descuento por visita de inspección',
      sub: `Monto predeterminado: $${Number(
        INSPECTION_DISCOUNT_DEFAULT
      ).toFixed(2)}`,
    },
    {
      value: 'repair',
      label: 'Descuento por visita de reparación',
      sub: `Monto predeterminado: $${Number(REPAIR_DISCOUNT_DEFAULT).toFixed(
        2
      )}`,
    },
  ]

  const canApplyVisitDiscount = useValidatePermission(
    VAPermissions.applyVisitDiscount
  )

  const dispatchCotizacion = useDispatch()

  // Precio Negociacion
  const [precioNegociacion, setPrecioNegociacion] = useState(true)
  // Box Mostrar Razones
  const [mostrarRazones, setMostrarRazones] = useState(false)
  // Razon Precio
  const [razonPrecio, setRazonPrecio] = useState({
    NegotiatedPriceBy: useSelector(
      state => state?.login?.user?.CustomerInfo?.CustomerId
    ),
    NegotiatedPriceByName: useSelector(
      state => state?.login?.user?.AuthenticationInfo?.UserName
    ),
    NegotiatedReason: null,
    NegotiatedReasonCode: null,
    NegotiatedReasonId: null,
    Price: parseFloat(product.Price),
    FinalPrice: parseFloat(product.FinalPrice),
    BasePrice: parseFloat(product.BasePrice),
    Amount: FormatMoney(product.Amount, false, 6),
    DiscountAmount: FormatMoney(product.DiscountAmount, false, 6),
    DiscountAmountLocal: FormatMoney(product.DiscountAmount, false, 6),
    AmountWithTax: FormatMoney(product.AmountWithTax, false, 6),
    // FirstPriceBase : parseFloat(product.BasePrice),
    // FirstDiscountAmount: parseFloat(product.DiscountAmount)
  })

  // List Razones
  const [razones, setRazones] = useState([])
  // Terminar cambio precio por razon
  const companyId = useSelector(state => state.company.CompanyId)
  const companyCode = useSelector(state => state.company.CompanyCode)
  const warehouseId = useSelector(state => state.company.WarehouseId)
  const productListId = useSelector(
    state => state.cotizacion.QuoteHeader.ProductListId
  )
  const customerId = useSelector(
    state => state.cotizacion.QuoteHeader.CustomerId
  )

  const [razonSelect, setRazonSelect] = useState(null)

  // Handle Mostrar Razones
  const handleMostrarRazones = () => {
    setMostrarRazones(!mostrarRazones)
  }

  const channelRef = useRef(null)
  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }
  const channel = channelRef.current

  // Handel State
  const handleChange = value => {
    setMarginError(null)
    setPriceInputValue(value)
    value = value.replace(/,/g, '')
    if (!precioNegociacion) {
      value =
        ((100 - parseFloat(value)) *
          (product.FinalPrice - product.DiscountAmount)) /
        100
    }
    const tempAmountWithTax =
      parseFloat(value) * product.Quantity * (1 + product.TaxCategoryValue)
    const tax = parseFloat(value) * product.TaxCategoryValue * product.Quantity
    setRazonPrecio(prevState => ({
      ...prevState,
      Price: parseFloat(value),
      Amount: parseFloat(value) * product.Quantity,
      AmountWithTax: tempAmountWithTax,
      Tax: tax,
    }))
  }

  const reasonDefault = razones.filter(
    r => r.ReasonId === 'D9C0EFFB-09F6-481B-ABDD-8B8D05081DF1'
  )
  const handleRazon = razon => {
    setRazonSelect(razon)
    setRazonPrecio(prevState => ({
      ...prevState,
      NegotiatedReason: razon.Name,
      NegotiatedReasonCode: razon.Code,
      NegotiatedReasonId: razon.ReasonId,
    }))
  }

  // Handle Check Precio Negociacion
  const handleChangeCheck = () => {
    setPrecioNegociacion(!precioNegociacion)
  }

  const handleDiscountTypeChange = e => {
    const type = e.target.value
    setDiscountType(type)
    if (type === 'inspection') setDiscountAmount(INSPECTION_DISCOUNT_DEFAULT)
    else if (type === 'repair') setDiscountAmount(REPAIR_DISCOUNT_DEFAULT)
    else {
      setDiscountAmount(null)
    }
  }

  // PRODUCT DISCOUNT MARGIN
  const getDiscountMargin = async () => {
    const payload = {
      CompanyId: companyId,
      CompanyCode: companyCode,
      WarehouseId: warehouseId,
      ProductId: product.ProductId,
      CustomerId: customerId,
      PriceListId: productListId,
      Qty: 1,
    }
    const Data = await dispatchCotizacion(getFinalPriceAction(payload))
    if (Data && Data?.length > 1) {
      setMaxDiscount(Data[1].FinalPrice)
      setMaxMargin(Data[1].DiscountPct)
    } else {
      throw new Error(Data)
    }
  }

  // Obtener Razones Precio
  const fetchRazonesPrecio = async () => {
    const payload = {
      reasonTypeId: 'CDD84712-0748-49DC-A58C-608470D04EDC',
      pageSize: 1000,
      pageNumber: 1,
    }
    const Data = await dispatchCotizacion(getRazonesPrecioAction(payload))
    if (Data && Data?.length > 0) {
      setRazones(Data)
    } else {
      throw new Error(Data)
    }
  }

  const cambiarPrecio = async (e, overridePrice = false) => {
    const isPriceChanged = priceInputValue !== '' && priceInputValue !== null

    if (isPriceChanged) {
      if (isNaN(razonPrecio.Price) || parseFloat(razonPrecio.Price) <= 0) {
        setMarginError('ErrPriceTitle')
        return
      }

      if (parseFloat(razonPrecio.Price) > MAX_PRICE) {
        setMarginError(
          `Error en el precio: límite excedido. El máximo permitido es: ${MAX_PRICE}`
        )
        return
      }
    }

    const effectivePrice = isPriceChanged
      ? parseFloat(razonPrecio.Price)
      : parseFloat(product.Price)

    if (discountType !== null && !(discountAmount > 0)) {
      const discountLabel =
        discountOptions.find(o => o.value === discountType)?.label ??
        'descuento'
      setMarginError(`El monto de ${discountLabel} debe ser mayor a 0.`)
      return
    }

    if (
      discountType !== null &&
      discountAmount !== null &&
      effectivePrice <= Number.parseFloat(discountAmount)
    ) {
      setMarginError(
        'El precio de negociación no puede ser menor al monto del descuento.'
      )
      return
    }

    if (
      isPriceChanged &&
      effectivePrice <= maxDiscount &&
      !razonPrecio.NegotiatedReason
    ) {
      handleMostrarRazones()
    } else {
      const newMargin = getMarginTotal(
        effectivePrice,
        product.Cost || product.AvgCost || 0.0,
        product.Quantity
      )
      setNewPerct(newMargin)
      if (!isPriceChanged || effectivePrice >= maxDiscount || overridePrice) {
        if (isPriceChanged) {
          razonPrecio.NegotiatedReason = reasonDefault[0]?.Name
          razonPrecio.NegotiatedReasonCode = reasonDefault[0]?.Code
          razonPrecio.NegotiatedReasonId = reasonDefault[0]?.ReasonId
        }
        setNuevoPrecio(razonPrecio)
        // check if setProductChangeValidation is set
        if (setProductChangeValidation) {
          setProductChangeValidation(true)
        }
        handleModalEditPrice()
        handleModalSuccesUpdatePrecio()
        const modifiedProduct = {
          ...product,
          ...razonPrecio,
          Margin: newMargin,
          Price: effectivePrice,
          isPriceChanged,
        }
        if (effectivePrice < modifiedProduct.BasePrice) {
          const discount = modifiedProduct.BasePrice - effectivePrice
          modifiedProduct.DiscountAmount = discount
          modifiedProduct.DiscountAmountLocal = discount
          modifiedProduct.descuento = discount
        } else {
          // set discounts to 0
          modifiedProduct.DiscountAmount = 0
          modifiedProduct.DiscountAmountLocal = 0
          modifiedProduct.DiscountPct = 0
          modifiedProduct.descuento = 0
        }
        modifiedProduct.VisitDiscountType = discountType ?? null
        modifiedProduct.VisitDiscountAmount =
          discountType !== null && discountAmount !== null
            ? Number.parseFloat(discountAmount) || 0
            : null
        const payload = {
          product: modifiedProduct,
        }
        dispatchCotizacion(setDiscount(payload))
        dispatchCotizacion(cotizacionPriceChange(razonPrecio))
        channel.postMessage({
          priceChange: {
            Price: effectivePrice,
            ProductId: modifiedProduct.ProductId,
          },
        })
      } else {
        setMarginError(
          `Precio fuera del margen permitido por ${(
            newMargin - maxMargin
          ).toFixed(2)}%`
        )
        setAnularMargen(true)
      }
    }
  }

  useEffect(() => {
    const handleClickOutside = e => {
      if (
        discountDropdownRef.current &&
        !discountDropdownRef.current.contains(e.target)
      ) {
        setDiscountDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    fetchRazonesPrecio()
    getDiscountMargin()
  }, [])

  return (
    <>
      <div className="edit-precio-modal-container">
        {mostrarRazones ? (
          <div data-testid="modal-reason-selection">
            <div className="razones-modal-header">
              <h2>Código de razón</h2>
              <span
                onClick={handleMostrarRazones}
                className="close-modal"
                data-testid="btn-close-reason-modal">
                <img src={no} alt="close" />
              </span>
            </div>
            <div className="razones-modal-body">
              {razones.length > 0 &&
                razones.map(razon => (
                  <li
                    key={razon?.ReasonId}
                    className={
                      razonSelect?.ReasonId === razon?.ReasonId
                        ? 'razones-option razon-selected'
                        : 'razones-option'
                    }
                    data-testid={`li-reason-option-${toTestId(
                      razon?.ReasonId
                    )}`}>
                    <div className="razon-text">
                      <label htmlFor={razon.ReasonId}>{razon.Name}</label>
                      <p>{razon.Description}</p>
                    </div>
                    <div className="razones-options-buttons">
                      {razonSelect?.ReasonId === razon?.ReasonId ? (
                        <FontAwesomeIcon icon={faCheck} />
                      ) : (
                        <input
                          type="radio"
                          id={razon.ReasonId}
                          name="price-change"
                          value={razon.ReasonId}
                          onClick={() => handleRazon(razon)}
                          data-testid={`input-reason-option-${toTestId(
                            razon.ReasonId
                          )}`}
                        />
                      )}
                    </div>
                  </li>
                ))}
              <div className="modal-buttons">
                <button
                  className="btn-continuar"
                  onClick={handleMostrarRazones}
                  data-testid="btn-reason-continue">
                  Continuar
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="edit-precio-modal-header">
              <h2>Solicitud de cambio de precios</h2>
              <span
                onClick={handleModalEditPrice}
                className="close-modal"
                data-testid="modal-close-price-button">
                <img src={no} alt="close" />
              </span>
            </div>
            <div className="edit-precio-modal-body">
              <p>Precio inicial ${product?.FinalPrice}</p>
              <button
                className="razones-button"
                onClick={handleMostrarRazones}
                data-testid="btn-select-reason">
                Selecciona código de razón
              </button>
              <div className="toggle">
                <p>
                  <span>{precioNegociacion ? 'Precio ' : 'Porcentaje '}</span>de
                  negociación
                </p>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={precioNegociacion}
                    name="precioNegociacion"
                    value={razonPrecio.precioNuevo}
                    onChange={handleChangeCheck}
                    data-testid="switch-negotiation-type"
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="currency-input">
                {precioNegociacion ? (
                  <button className="price-sign">$</button>
                ) : (
                  <button className="price-sign">%</button>
                )}
                <NumericFormat
                  thousandSeparator={true}
                  decimalSeparator={'.'}
                  decimalScale={4}
                  name="precioNuevo"
                  id="precioNuevo"
                  value={priceInputValue}
                  onChange={event => handleChange(event.target.value)}
                  placeholder="Introduce el nuevo precio"
                  data-testid="input-price"
                />
              </div>
              {product.ProductTypeId === SERVICE_PRODUCT_TYPE_ID &&
                canApplyVisitDiscount && (
                  <div className="discount-section">
                    <h3 className="discount-section-title">
                      Descuento adicionales
                    </h3>
                    <p className="discount-section-description">
                      Selecciona si este servicio incluye descuento por visita
                      de inspección o reparación
                    </p>
                    <div className="discount-select" ref={discountDropdownRef}>
                      <button
                        type="button"
                        className="discount-select-trigger"
                        onClick={() => setDiscountDropdownOpen(prev => !prev)}
                        data-testid="select-discount-type">
                        <span>
                          {
                            discountOptions.find(o => o.value === discountType)
                              ?.label
                          }
                        </span>
                        <span className="discount-select-chevron" />
                      </button>
                      {discountDropdownOpen && (
                        <div className="discount-select-dropdown">
                          {discountOptions.map(opt => (
                            <button
                              type="button"
                              key={opt.value}
                              className={`discount-option${
                                discountType === opt.value
                                  ? ' discount-option-selected'
                                  : ''
                              }`}
                              onClick={() => {
                                handleDiscountTypeChange({
                                  target: { value: opt.value },
                                })
                                setDiscountDropdownOpen(false)
                              }}
                              data-testid={`option-discount-${opt.value}`}>
                              <span className="discount-option-title">
                                {opt.label}
                              </span>
                              {opt.sub && (
                                <p className="discount-option-sub">{opt.sub}</p>
                              )}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    <p className="discount-amount-label">Monto del descuento</p>
                    <div className="currency-input">
                      <button
                        className="price-sign"
                        disabled={discountType === null}>
                        $
                      </button>
                      <NumericFormat
                        thousandSeparator={true}
                        decimalSeparator={'.'}
                        decimalScale={2}
                        allowNegative={false}
                        isAllowed={({ floatValue }) =>
                          floatValue === undefined || floatValue <= MAX_PRICE
                        }
                        value={discountAmount ?? ''}
                        disabled={discountType === null}
                        onValueChange={({ floatValue }) => {
                          setMarginError(null)
                          setDiscountAmount(floatValue ?? null)
                        }}
                        placeholder="00"
                        data-testid="input-discount-amount"
                      />
                    </div>
                  </div>
                )}
            </div>
            {marginError && (
              <p
                className="margin-error-message"
                data-testid="margin-error-message">
                {t(marginError)}
              </p>
            )}
            <div className="modal-footer-buttons">
              <button
                className="btn-cerrar"
                onClick={handleModalEditPrice}
                data-testid="btn-close-price-modal">
                Cerrar
              </button>
              <button
                className="btn-aplicar-descuento"
                onClick={cambiarPrecio}
                data-testid="btn-apply-discount">
                Aplicar descuento
              </button>
            </div>
          </>
        )}
      </div>

      {/* Mostrar Razones de Cambio de Precio */}
      <Modal
        show={anularMargen}
        container={productsRef?.current ? productsRef.current : null}
        backdrop={false}
        className="modal-clase-price-change"
        centered
        data-testid="modal-reasons-price-change">
        <div className="modal-price-change-allow">
          <span
            onClick={() => setAnularMargen(false)}
            className="close-modal"
            data-testid="btn-close-margin-confirmation-modal">
            <img src={no} alt="close" />
          </span>
          <div className="price-allow-text">
            <h2>El precio esta debajo del margen permitido</h2>
            <h2>¿Deseas continuar?</h2>
          </div>
          <div className="price-allow-buttons">
            <button
              className="price-allow-true"
              onClick={(e, overridePrice = true) =>
                cambiarPrecio(e, overridePrice)
              }
              data-testid="btn-margin-confirm-yes">
              Si
            </button>
            <button
              className="price-allow-false"
              onClick={() => setAnularMargen(false)}
              data-testid="btn-margin-confirm-no">
              No
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default PrecioProducto
